// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-steps {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
}

.step-section {
  margin-bottom: 2rem;
}

.step-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: purple;
  margin-bottom: 1rem;
}

.admin-action-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;   /* center items horizontally */
  align-items: center;       /* optional: center vertically if needed */
  gap: 1rem;
  padding: 1rem;
}


.admin-action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 120px;
  text-align: center;
  background-color: #d9d3db;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  text-decoration: none;
  color: #333;
  transition: transform 0.2s, box-shadow 0.2s;
}

.admin-action-card:hover {
   transform: scale(1.05); /* Enlarge the card slightly on hover */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/Admin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB,IAAI,8BAA8B;EACzD,mBAAmB,QAAQ,0CAA0C;EACrE,SAAS;EACT,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;GACG,sBAAsB,EAAE,uCAAuC;EAChE,2CAA2C,EAAE,iCAAiC;AAChF","sourcesContent":[".admin-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 1rem;\n}\n\n.step-section {\n  margin-bottom: 2rem;\n}\n\n.step-title {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: purple;\n  margin-bottom: 1rem;\n}\n\n.admin-action-cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;   /* center items horizontally */\n  align-items: center;       /* optional: center vertically if needed */\n  gap: 1rem;\n  padding: 1rem;\n}\n\n\n.admin-action-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 160px;\n  height: 120px;\n  text-align: center;\n  background-color: #d9d3db;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  text-decoration: none;\n  color: #333;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.admin-action-card:hover {\n   transform: scale(1.05); /* Enlarge the card slightly on hover */\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
